
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Card, Grid, Stack, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import EditIcon from 'common/customIcons/edit';
import { useEffect, useState } from 'react';
import colors from 'assets/theme/base/colors';
import CommonLayout from 'layouts/DashboardLayout';
import { useDispatch, useSelector } from 'react-redux';
import CannabinoidsList from './CannabinoidsList';
import ManageMainCannabinoidBanners from './ManageMainCannabinoidBanners';
import { getMainCannabinoid } from '../../../redux/slices/cannabinoids';
import { getData } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';

export default function ManageCannabinoids() {
  const [currentTab, setCurrentTab] = useState('');
  const dispatch = useDispatch();
  const { mainCannabinoid = {} } = useSelector(state => state.cannabinoids);
  const { search } = useLocation();
  const navigate = useNavigate();
  const [currentCannabinoidsTab, setCurrentCannabinoids] = useState('manage_cannabinoids');
  const { grey } = colors;
  const [searchParams] = useSearchParams();
  const { user = {} } = useSelector((state) => state.auth)
  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Manage Website", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Manage Website", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Manage Website", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Manage Website", "Delete");

  const [mount, setMount] = useState(false);
  useEffect(() => {
    if (!mount) return;
    if (search) {
      const selectedTab = search?.split('=')?.[1] || '';
      if (selectedTab !== currentTab) {
        navigate(`/manage-cannabinoids?cannabinoidTab=${selectedTab}`);
        setCurrentTab(selectedTab);
      }
    }
    else {
      navigate('/manage-cannabinoids?cannabinoidTab=main_cannabinoid');
      setCurrentTab('');
    }
  }, [search, mount]);

  useEffect(() => {
    dispatch(getMainCannabinoid());
  }, []);

  useEffect(() => {
    setMount(true);
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <>
      <CommonLayout>
        {

          <>
            {
              searchParams.get('cannabinoidTab') === 'main_cannabinoid' && <Box pt={{ xs: 2, sm: 3, lg: 4 }} pl={{ xs: 2, sm: 3, lg: 4 }} pr={{ xs: 2, sm: 3, lg: 4 }} className="cannabinoids-tabs">
                <Stack direction='row' gap={1} sx={{ background: '#ffffff' }}>
                  <Button onClick={() => {
                    setCurrentCannabinoids('manage_cannabinoids');
                  }} variant='outlined' sx={{ color: '#2E2E3A' }} className={currentCannabinoidsTab === 'manage_cannabinoids' ? 'active' : ''} >
                    Manage Cannabinoids
                  </Button>
                  <Button className={currentCannabinoidsTab === 'manage_banners' ? 'active' : ''} onClick={() => {
                    setCurrentCannabinoids('manage_banners');
                  }} variant='outlined' sx={{ color: '#2E2E3A' }}>
                    Manage Banners
                  </Button>
                </Stack>
              </Box>
            }
            {
              currentTab && currentTab === 'main_cannabinoid' ?
                <>
                  {
                    currentCannabinoidsTab === 'manage_cannabinoids' && <Box p={{ xs: 2, sm: 3, lg: 4 }}>
                      <Card sx={{ p: 3, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
                        <Stack direction="row" justifyContent="space-between" spacing={3} mb={3}>
                          <Typography variant='h4' fontWeight="semibold" ml={.75}>Manage Cannabinoids</Typography>
                          {
                            canEdit &&
                            <MDButton
                              type='button'
                              variant='outlined'
                              color='dark'
                              size="small"
                              startIcon={<EditIcon width='15px' height='15px' />}
                              onClick={() => navigate('/manage-cannabinoids/main-cannabinoid/main-page')}
                            >
                              Edit
                            </MDButton>
                          }
                        </Stack>
                        {
                          canView &&
                          <Grid container alignItems="center" spacing={{ xs: 3 }} mb={2}>
                            <Grid item xs={12}>
                              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Title</Typography>
                              <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                                __html: mainCannabinoid?.title || '-'
                              }}></Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Meta Title</Typography>
                              <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                                __html: mainCannabinoid?.metaTitle || '-'
                              }}></Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={0.5}>Meta Description</Typography>
                              <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                                __html: mainCannabinoid?.metaDescription || '-'
                              }}></Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                              <Typography className="quill-text-editor-view" component="div" fontWeight="medium" variant="h6" dangerouslySetInnerHTML={{
                                __html: mainCannabinoid?.description || '-'
                              }}></Typography>
                            </Grid>
                          </Grid>
                        }

                      </Card>
                    </Box>
                  }
                  {
                    currentCannabinoidsTab === 'manage_banners' && <ManageMainCannabinoidBanners canCreate={canCreate} canEdit={canEdit} canView={canView} canDelete={canDelete} />
                  }

                </> : currentTab && currentTab === 'cannabinoids' ? <CannabinoidsList canCreate={canCreate} canEdit={canEdit} canView={canView} canDelete={canDelete} /> : null
            }
          </>
        }
      </CommonLayout>
    </>
  );
}
